import {gql} from "@apollo/client";

export const ADD_SERVICE_TO_CART_MUTATION = gql`
  mutation ($serviceId: Int!) {
    addServiceToCart(options: {serviceId: $serviceId}) {
      data {
        id
        service {
          id
          name
        }
        customer {
          id
          firstName
          lastName
        }
      }
      errors {
        message
      }
    }
  }
`;

export const REMOVE_SERVICE_FROM_CART_MUTATION = gql`
  mutation ($id: Float!) {
    removeItemFromCart(id: $id) {
      message
      errors {
        message
      }
    }
  }
`;

export const CREATE_MY_ORDER_MUTATION = gql`
  mutation CREATE_MY_ORDER(
    $agencyId: Int!
    $services: [OrderedServiceInputType!]!
    $masterId: Int
    $accountHolder: String
    $billTo: BillingEnumType
    $billingAddress: BillingDetailInputType!
  ) {
    createMyOrder(
      options: {
        agencyId: $agencyId
        services: $services
        masterId: $masterId
        billingAddress: $billingAddress
        billTo: $billTo
        accountHolder: $accountHolder
      }
    ) {
      errors {
        message
      }
      data {
        id
        orderedService {
          id
          service {
            id
          }
          fields {
            fieldId
            data {
              name
              value
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_MY_ORDER_MUTATION = gql`
  mutation UPDATE_MY_ORDER(
    $agencyId: Int!
    $services: [OrderedServiceInputType!]!
    $billingAddress: BillingDetailInputType!
    $id: Int!
    $billTo: BillingEnumType
    $note: String
    $isTermsAndConditionAccepted: Boolean
    $accountHolder: String
  ) {
    updateMyOrder(
      options: {
        id: $id
        agencyId: $agencyId
        accountHolder: $accountHolder
        services: $services
        billingAddress: $billingAddress
        isTermsAndConditionAccepted: $isTermsAndConditionAccepted
        isPublished: true
        billTo: $billTo
        note: $note
      }
    ) {
      errors {
        message
      }
      data {
        id
        orderedService {
          id
          service {
            id
          }
          fields {
            fieldId
            data {
              name
              value
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_ORDER_MESSAGE_STATUS = gql`
  mutation ($id: Int!) {
    updateOrderMessageStatus(id: $id) {
      errors {
        message
      }
      message
    }
  }
`;
